<template>
  <GenericBanner :displayed="displayed" class="search-banner md:py-8 bg-bannerGreen-search-bar">
    <IconCross
      @click="$emit('closeButtonClick')"
      class="absolute top-0 right-2 hidden h-5 w-4 cursor-pointer md:right-8 md:block"
    />

    <div class="flex w-full flex-col justify-center gap-4 md:hidden">
      <p class="text-center text-lg font-bold">
        To recruit, call
        <a
          v-html="telephoneNumberNbsp"
          :href="`tel:${telephoneNumber}`"
          class="font-bold underline"
        />
      </p>
      <InputButton
        class="border-2 border-black bg-lime-600 hover:bg-lime-400"
        :block="true"
        styleType="none"
        @click="$emit('closeButtonClick')"
      >
        Close
      </InputButton>
    </div>

    <div class="hidden w-full md:flex md:flex-col md:gap-7 px-8">
      <p class="text-3xl font-bold">
        If you're short on time or don't know which agencies to contact...
      </p>
      <p class="text-xl">
        Our expert team will be happy to send your requirements to the right
        agencies on your behalf.

        <template v-if="telephoneNumber === ''">
          Start a
          <span
            @click="$emit('openLiveChat')"
            class="cursor-pointer font-bold underline"
          >
            live chat.
          </span>
        </template>
        <template v-else
          >Just call
          <a
            v-html="telephoneNumberNbsp"
            :href="`tel:${telephoneNumber}`"
            class="font-bold underline"
          />
          or start a
          <span
            @click="$emit('openLiveChat')"
            class="cursor-pointer font-bold underline"
          >
            live chat.
          </span>
        </template>
      </p>
    </div>
  </GenericBanner>
</template>

<script>
import GenericBanner from 'Components/Banners/GenericBanner';
import IconCross from 'Components/Icons/IconCross';
import InputButton from 'Components/InputButton.vue';

export default {
  name: 'EmployerSearchBanner',
  components: {
    GenericBanner,
    IconCross,
    InputButton,
  },
  props: {
    displayed: {
      type: Boolean,
      default: true,
    },
    telephoneNumber: {
      type: String,
      default: '0345 557 8401',
    },
  },
  computed: {
    telephoneNumberNbsp() {
      return this.telephoneNumber.trim().replaceAll(' ', '&nbsp;');
    },
  },
};
</script>
